import type { FaireProductEntity } from "../../entity_types/product";

export const p_edjyzqfr64: FaireProductEntity = {
  token: "p_edjyzqfr64",
  type: "product",
  name: "Side By Side Chai",
  brandToken: "b_bzs8cq537a",
  brandName: "Side By Side Chai",
  imageUrl:
    "https://cdn.faire.com/fastly/895cc803e3a3c50847f90cb9d8894a3ca3361c3f5e7198c984f4f4f33a25c647.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/31c78af6f9600d98ae71ad375b65c49ebca75032fa9ea3d341547329fb4cf58b.jpeg",
    "https://cdn.faire.com/fastly/01aaaa755723128e3e0724228c1e1f418878702a9004efbbed24481f285256b5.jpeg",
    "https://cdn.faire.com/fastly/7aa7a936251b91944a13eba3619b59346489fc7198425b05afbc92ce1d285c4f.jpeg",
    "https://cdn.faire.com/fastly/0b5b91738ffda2bf42c67bf005501f13c519e3eff210b8348caeeb910810ab61.jpeg",
    "https://cdn.faire.com/fastly/375bf534a43b0dc2a7f19ca36e962024515622caf5299b151a0423860b34c69f.jpeg",
  ],
  priceDollars: 11.5,
  description:
    "Our chai tea latte mix is created in and distributed from Nashville TN. With the non-coffee drinker in mind who wants to have a beverage they're proud to rep.\n\nThere's no better way to connect with people than over a cup of coffee or tea and same goes for life; there's no better way to live life with the people around us than Side by Side.\n\nSide by Side Chai tea latte mix is perfect to enjoy in the comfort of your own home. Simply mix with your favorite milk or hot water.\n\n• Contains milk and caffeine.\n• Shelf life is 1 year.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:09.204Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
